import Vue from "vue";
import VueOptions from "./utils/VueOptions";
import App from "./App.vue";
import router from "./router";
import notification from "vue-notification";
import stash from "vue-stash";
import InfiniteLoading from "vue-infinite-loading";
import VueTheMask from "vue-the-mask";
import money from "v-money";
import filters from "./utils/filters";
window.dayjs = require("dayjs");
import VTooltip from "v-tooltip";
import * as VueGoogleMaps from "vue2-google-maps";
import Draggable from 'vuedraggable'

import '@fullcalendar/core/vdom'
import '@fullcalendar/vue'

import {
  Avatar,
  Badge,
  Collapse,
  CollapseItem,
  DatePicker,
  TimeSelect,
  Select,
  Option,
  OptionGroup,
  RadioGroup,
  RadioButton,
  Radio,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Checkbox,
  Input,
  InputNumber,
  Form,
  FormItem,
  CheckboxGroup,
  Autocomplete,
  Upload,
  Dialog,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Timeline,
  TimelineItem,
  Popover,
  CheckboxButton,
  Switch,
  Slider,
  Cascader,
  ButtonGroup,
  Progress,
  Table,
  TableColumn,
  Tag,
  Alert,
  Tabs,
  TabPane,
  Steps,
  Step,
} from "element-ui";
import "./assets/element/index2.css";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";
import InputMoney from './components/InputMoney'

locale.use(lang);

Vue.component(Autocomplete.name, Autocomplete);
Vue.component(Avatar.name, Avatar);
Vue.component(Badge.name, Badge);
Vue.component(Button.name, Button);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(Input.name, Input);
Vue.component(InputNumber.name, InputNumber);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(OptionGroup.name, OptionGroup);
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(Upload.name, Upload);
Vue.component(Dialog.name, Dialog);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(BreadcrumbItem.name, BreadcrumbItem);
Vue.component(Timeline.name, Timeline);
Vue.component(TimelineItem.name, TimelineItem);
Vue.component(Popover.name, Popover)
Vue.component(CheckboxButton.name, CheckboxButton)
Vue.component(Switch.name, Switch)
Vue.component(Slider.name, Slider)
Vue.component(Cascader.name, Cascader)
Vue.component(ButtonGroup.name, ButtonGroup)
Vue.component(Progress.name, Progress)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Tag.name, Tag)
Vue.component(Alert.name, Alert)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Steps.name, Steps)
Vue.component(Step.name, Step)

Vue.config.productionTip = false;
Vue.use(VTooltip);
Vue.use(Draggable)
Vue.use(notification);
Vue.use(stash);
Vue.use(InfiniteLoading, {
  slots: {
    noMore: "",
    noResults: ""
  }
});
Vue.use(VueTheMask);
Vue.use(money, {
  decimal: ".",
  thousands: ",",
  prefix: "",
  suffix: "",
  precision: 0,
  masked: false
});
Vue.component(InputMoney.name, InputMoney)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.use(VueGoogleMaps, {
  load: {
    key:
      process.env.VUE_APP_GOOGLE_MAPS_JS_API_KEY ||
      process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: "places"
  },
  autobindAllEvents: false
});

const initialState = {
  appSession: {
    now: Date.now()
  },
  cachedTimestamps: {},
  componentSession: {},
  pageSession: {},
  member: {},
  originalMember: {},
  cookie: {},
  models: {
    now: Date.now()
  },
  slugs: {},
  requestIsPending: false,
  saveRequestIsPending: false,
  marketplace: {}
};

window.Vue = new Vue({
  router,
  data: () => ({
    store: initialState
  }),
  methods: {
    initialState() {
      var state = JSON.parse(JSON.stringify(initialState));
      return state;
    }
  },
  render: h => h(App)
}).$mount("#app");

VueOptions.initialize();
